'use client';
import { Fragment } from 'react';
import styles from './description.module.scss';
import { DescriptionProps, DescriptionType } from './description.types';
import { DescriptionElement } from './description.utils';
import { useLocale } from 'next-intl';

const DescriptionContent = (props: DescriptionProps) => {
  const { data } = props;
  const locale = useLocale();
  const trasnlatedDescription =
    locale === 'ru'
      ? data?.product?.description
      : data?.product?.translation?.description;
  const description = JSON?.parse(trasnlatedDescription || '{}');

  return (
    <>
      <div style={{ overflow: 'hidden' }} className={styles.wrapper}>
        {description?.blocks?.map((item: DescriptionType) => {
          return <Fragment key={item.id}>{DescriptionElement(item)}</Fragment>;
        })}
      </div>
    </>
  );
};

export default DescriptionContent;
